import {
    FILE_ADD,
    FILE_PROGRESS,
    FILE_SUCCESS,
    FILE_ERROR,
    FILE_DELETE,
    FILE_UPDATE,
} from "../actions/FileActions";

const initialState = {
    files: [],
};

function isCurrentFile(item, action) {
    const file = action.payload;
    return item.uid === file.uid;
}

export default function FileUploaderReducer(state = initialState, action) {
    switch (action.type) {
        case FILE_ADD:
            const files = [...state.files];
            files.unshift(action.payload);
            return {
                ...state,
                files: files
            };

        case FILE_UPDATE:
        case FILE_PROGRESS:
        case FILE_SUCCESS:
        case FILE_ERROR:
            state.files = state.files.map(
                item => isCurrentFile(item, action) ? {...item, ...action.payload} : item
            );
            return {...state};

        case FILE_DELETE:
            state.files = state.files.filter(item => {
                return !isCurrentFile(item, action);
            });
            return {...state};
    }

    return state;
}